module.exports = "/_next/static/images/83be3febc3e5dad9e106d50244505f3e-hands-holding-cards-lg@3x.jpg.webp";